import React, { useState, useEffect, useRef } from "react";
import {
    Container,
    Box,
    Stack,
    Typography,
    Divider,
    Button,
    CardMedia,
    Card,
    CardContent,
    ButtonGroup,
    IconButton,
    Paper,
    Chip,
    Grid,
    Skeleton,
    // Container,
} from "@mui/material";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import useTheme from "@mui/system/useTheme";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from '@mui/icons-material/Favorite';
import { addToWishlist, removeFromWishlist, getUserWishList, addToCart, } from "../../services/user";
import useMediaQuery from '@mui/material/useMediaQuery';
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';
import { getFeaturedProductList } from "../../services/home";
import toast from "react-hot-toast";
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import trackEvent from "../../utils/trackEvent";
import { useCart } from "../../utils/CartContext";

const Featuredproduct = ({ handleProductClick }) => {
    const theme = useTheme();
    const loggedIn = localStorage.getItem("is_login");
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const navigate = useNavigate();
    const [wishlist, setWishlist] = useState([]);
    const [quantity, setQuantity] = useState(1);
    const isLgScreen = useMediaQuery(theme.breakpoints.up('lg'));
    const [product2, setProduct2] = useState([]);
    // const [addedToCart, setAddedToCart] = useState(false);
    const [openBackdrop, setOpenBackdrop] = useState(false);
    const isxlargeScrren =  useMediaQuery(theme.breakpoints.up("xl"));
    const isLargeScreen = useMediaQuery(theme.breakpoints.up("lg"));
    const isXsScreen = useMediaQuery(theme.breakpoints.up("xs"));
    const isSmallScreen = useMediaQuery(theme.breakpoints.up("sm"));
    const isMediumScreen = useMediaQuery(theme.breakpoints.up("md"));
    const { fetchCartCount } = useCart();


    const handleAddToCart = async (product_id) => {
        if (loggedIn) {
            setOpenBackdrop(true);
            try{
                const response = await addToCart(product_id, quantity);
                if (response.code === 200 && response.status === "success") {
                    trackEvent("add_to_cart", {
                        product: {
                          product_id: product_id,
                          product_quantity: quantity,
                        },
                      });
                    setOpenBackdrop(false);
                    toast.success("Item added to cart", {
                        position: "bottom-center",
                    });
                } else if (response.status === "error" && response.code === 203) {
                    // ToastNotification("Product is out of stock", "error");
                    toast.error("Product is out of stock", {
                        position: "bottom-center",
                    })
                    setOpenBackdrop(false);
                } 
                fetchCartCount();
            }catch(e){
                setOpenBackdrop(false);
                toast.error("something went wrong try again after some time");
            }finally{
                setOpenBackdrop(false);
            }
        } else {
            navigate("/login");
        }
    };


    const getFeaturedProduct = async () => {
        const result = await getFeaturedProductList();
        if (result?.code === 200) {
            setProduct2(result?.data);
        }
    };

    useEffect(() => {
        getFeaturedProduct();
    }, []);
  
  
    // const visibleProduct = categorys.slice(0, 5);
    let visibleProductCount = 8; // Default number of visible categories
  
    if (isXsScreen) {
      visibleProductCount = 9;
    }
    if (isSmallScreen) {
      visibleProductCount = 8;
    }
    if (isLargeScreen) {
      visibleProductCount = 8;
    }
    if (isMediumScreen) {
      visibleProductCount = 8;
    }
    if (isxlargeScrren) {
      visibleProductCount = 10;
    }
    
  
    const visibleProduct = product2.slice(0, visibleProductCount);

    useEffect(() => {
        const fetchWishlist = async () => {
            try {
                const userWishlist = await getUserWishList();
                if(userWishlist.code === 200){
                setWishlist(userWishlist?.data.map((item) => ({ id: item.id, isFavorite: true })));
                }else{
                    setWishlist([]);
                }
            } catch (error) {
                console.log('Error fetching wishlist:', error);
            }
        };
        fetchWishlist();
    }, []);

    const handleFavoriteClick = async (productId) => {
        if (loggedIn) {
            try {
                const isProductInWishlist = wishlist.find((p) => p.id === productId);

                if (isProductInWishlist) {
                    await removeFromWishlist(productId);
                    setWishlist(wishlist.filter((item) => item.id !== productId));
                    // ToastNotification("Item removed from wishlist", "success");
                    toast.success("Item removed from wishlist", {
                        position: "bottom-center",
                    })
                    
                } else {
                    await addToWishlist(productId);
                    setWishlist([...wishlist, { id: productId, isFavorite: true }]);
                    toast.success("Item added to Wishlsit", {
                        position: "bottom-center",
                    })
                }
            } catch (error) {
                console.log('Error updating wishlist:', error);
            }
        } else {
            navigate("/login");
        }
    };

    const renderSkeletons = () => {
        return [0, 1, 2, 3, 4, 5].map((_, index) => (
            <Grid key={index} item xs={6} sm={4} md={4} sx={{ height: "200px" }}>
                <Skeleton variant="rectangular" height={100} />
                <Skeleton />
                <Skeleton width="60%" />
            </Grid>
        ));
    };

    return (
        <>
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={openBackdrop}>
                <CircularProgress color="inherit" />
            </Backdrop>

            <Grid
                container
                rowSpacing={1.5}
                columnSpacing={2.5}
                sx={{
                    alignItems: "center",
                    justifyContent: { lg: 'flex-start', md: "center", sm: "center", xs: "flex-start" },
                    marginTop: {lg:"25px", md:"20px", sm:"20px", xs:"9px"},
                    overflowX: 'auto',
                    '@media (max-width: 600px)': { flexDirection: 'row', flexWrap: 'nowrap' },
                    // justifyContent: { lg: 'center', md: "center" },
                }}
            >
                {product2.length > 0 ? (
                    visibleProduct.map((item, index) => (
                        <Grid item key={index}
                            sx={{
                                marginTop: "10px",
                                marginBottom: { xs: "10px" },
                            }}
                        >
                            <Card
                                className="Featured_product"
                                onClick={() => handleProductClick(item)}
                                elevation={0}
                                sx={{
                                    width: {xl:"240px", xs: '300px', lg: '254px', md: "254px", sm: "250px" },
                                    height: '143px',
                                    padding: "2px 2px 2px 2px",
                                    background: "rgba(255, 255, 255, 1)",
                                    border: "1px ",
                                    borderRadius: "10px",
                                    boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.15)",
                                }}
                            >
                                {/* Discount chip */}
                                <Chip
                                    label={item.discount_percent === 0 ? "Online Offer" : `${item.discount_percent}% off`}
                                    sx={{
                                        paddingTop: "2px",
                                        borderRadius: "20px",
                                        fontSize: "12px",
                                        height: "22px",
                                        fontFamily: "'Bebas Neue', sans-serif",
                                        width: "100px",
                                        fontWeight: "100",
                                        backgroundColor: "#003398",
                                        color: "#fff",
                                        position: "absolute",
                                        zIndex: "99",
                                        top: "8px",
                                        right: "10px",
                                    }}
                                />

                                {/* Wishlist button */}
                                <IconButton
                                    aria-label="wishlist"
                                    sx={{
                                        position: "absolute",
                                        top: "0",
                                        left: "0",
                                        fontSize: "20px",
                                        zIndex: 1,
                                    }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleFavoriteClick(item.id);
                                    }}
                                >
                                    {wishlist.find((p) => p.id === item.id)?.isFavorite ? (
                                        <FavoriteIcon sx={{ fontSize: "1.5rem", color: "red" }} />
                                    ) : (
                                        <FavoriteBorderIcon sx={{ fontSize: "1.5rem" }} />
                                    )}
                                </IconButton>

                                <Grid container mt={4} padding={"5px"} gap={1} justifyContent="center" alignItems="center" >
                                    {/* Product image */}
                                    <Grid item lg={4} md={3} xs={3}>
                                        <Box
                                            display={"flex"}
                                            flexGrow={1}
                                            justifyContent={"center"}
                                            alignItems={"center"}
                                            height={"100px"}>
                                            <CardMedia
                                                component="img"
                                                image={item.product_image}
                                                alt="product"
                                                sx={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "contain",
                                                }}
                                            />
                                        </Box>
                                    </Grid>
                                    {/* Product details */}
                                    <Grid item lg={7.5} md={8} xs={8} >
                                        <Box
                                            flexGrow={1}
                                            justifyContent={"center"}
                                            alignItems={"center"}
                                        >
                                            <Typography sx={{
                                                fontFamily: "'Bebas Neue', sans-serif",
                                                fontWeight: 500,
                                                color: "#000000",
                                                fontSize: "18px",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                maxWidth: "100%",
                                                textAlign: "left",
                                            }}>
                                                {item.product_name.length > 27 ? `${item.product_name.substring(0, 27)}...` : item.product_name}
                                            </Typography>

                                            {/* Product price */}
                                            {Number(item.price) > item.discount && item.discount > 0 ? (
                                                <Box display={"flex"} justifyContent="flex-start" alignItems="left">
                                                    <Typography sx={{ fontFamily: "'Barlow', sans-serif", fontSize: "16px", fontWeight: 500, color: "rgba(255, 0, 0, 1)" }}>
                                                        ₹{item.discount}{" "}
                                                    </Typography>
                                                    <Typography
                                                        marginLeft={"8px"}
                                                        color={"#9b9b9b"}
                                                        fontSize={"16px"}
                                                        sx={{
                                                            textDecoration: "line-through",
                                                        }}
                                                    >
                                                        {" "}
                                                        MRP ₹{item.price}
                                                    </Typography>
                                                </Box>
                                            ) : (
                                                <Box display={"flex"} justifyContent="flex-start" alignItems="left">
                                                    <Typography sx={{ fontFamily: "'Barlow', sans-serif", fontSize: "16px", fontWeight: 500, color: "rgba(255, 0, 0, 1)" }}>
                                                        ₹{item.price}{" "}
                                                    </Typography>
                                                </Box>
                                            )}

                                            {/* Add to cart button */}
                                            <Button
                                                variant="contained"
                                                endIcon={<ArrowForwardOutlinedIcon style={{ fontSize: '15px' }} />}
                                                sx={{
                                                    width: "125px",
                                                    height: "26px",
                                                    fontSize: "14px",
                                                    overflow: "hidden",
                                                    lineHeight: "16.8px",
                                                    textOverflow: "ellipsis",
                                                    fontFamily: "'Bebas Neue', sans-serif",
                                                    whiteSpace: "nowrap",
                                                    borderRadius: "7px",
                                                    backgroundColor: "#FF6633",
                                                    '&:hover': {
                                                        backgroundColor: '#FF663e',
                                                    },
                                                }}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleAddToCart(item.id,"","",1);
                                                }}
                                            >
                                                {"Add to Cart"}
                                            </Button>

                                        </Box>
                                        {/* Product name */}
                                    </Grid>
                                </Grid>
                            </Card>
                        </Grid>
                    ))
                ) : (
                    renderSkeletons()
                )}

            </Grid>
        </>
    );
};

export default Featuredproduct;
